import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'
import PlayerSelector from './PlayerSelector'
import PlayerSelectorModal from './templates/PlayerSelectorModal'

function AddPlayerSquad({teamId}) {

    const [playerId, setPlayerId] = useState("")
    const [player, setPlayer] = useState(null)

    const [image, setImage] = useState("")
    const [name, setName] = useState("");
    const [playerParentId, setPlayerParentId] = useState(0)
    const [position, setPosition] = useState(1);

    const [error, setError] = useState("");
    const [added, setAdded] = useState(false)

    async function addPlayerHandler(e) {
        e.preventDefault()
        try {
            
            const squadRef = firestore.collection("teams").doc(teamId).collection("players");

            const data = {
                player_image: image,
                player_name: name,
                player_parent_id: playerParentId,
                position,
                player_number: player.player_number || "99"
            }
            squadRef.add(data);
            setAdded(true)
        } catch (error) {
            setError(error.message)
            setAdded(false)
        }

    }

    useEffect(() => {
        // Get global players and selected players parent info
        if (player) {
            setImage(player.player_image)
            setName(player.player_name);
            setPlayerParentId(player.id);
            setPlayerId(player.id)
        }
    }, [player])

    return (
        <form onSubmit={addPlayerHandler}>
            <PlayerSelector playerId={playerId} setPlayerId={setPlayerId} setPlayer={setPlayer} />
            <PlayerSelectorModal selectedPlayer={player} setSelectedPlayer={setPlayer} />

            {player && (
                <div className="col-lg-4 col-md-6 mx-auto">
                    <div className="card">
                        <img src={image} alt={name} className="img-fluid"/>
                        <div className="card-body">
                            <p>{name}</p>
                            <small> {playerId || "No player id"}</small>
                            
                        </div>
                    </div>
                </div>
            )}

            {error && <div className="alert alert-danger">{error}</div>}
            {added && <div className="alert alert-success">Lagt til!</div>}
            <button className="btn btn-primary btn-rounded btn-block">Legg til spiller i tropp</button>
        </form>
    )

}
export default AddPlayerSquad